import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../styles/Footer.scss';

const Footer = () => {
  const [show, setShow] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    setShow(pathname !== '/sign-in');
  }, [pathname]);

  return show ? (
    <div className="footer">
      <div className="left-content">
        <h1>KNOW YOUR FUTURE WITH ALNAIR</h1>
        <p>
          An immersive experience specially designed to introduce event
          attendees to cutting-edge technologies.
        </p>
        <p className="copyright">© Copyright 2022 SoftServe</p>
      </div>
      <div className="nav-menu">
        <ul>
          <li>
            <NavLink to="/home">Home</NavLink>
          </li>
          <li>
            <NavLink to="/gallery">Gallery</NavLink>
          </li>
          {/* <li>
            <NavLink to="/how-it-works">How it works</NavLink>
          </li> */}
          <li>
            <NavLink to="/contact-us">Contact us</NavLink>
          </li>
          <li>
            <a
              className="soft-serve"
              href="https://www.softserveinc.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.softserveinc.com
            </a>
          </li>
        </ul>
      </div>
      <div className="right-content">
        <p className="copyright">© Copyright 2022 SoftServe</p>
        <a
          href="https://www.softserveinc.com/uk-ua/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        <a
          href="https://www.softserveinc.com/uk-ua/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
        <a
          className="soft-serve"
          href="https://www.softserveinc.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          softserveinc.com
        </a>
      </div>
    </div>
  ) : null;
};

export default Footer;
